<script>
  import ValidationMessage from '../../../../components/form/ValidationMessage.vue'
  import * as restfulService from '../../../../services/restfulService'
  import * as notifyService from '../../../../services/notifyService'
  import DataService from '../../../../services/dataService'
  import bus from '@utils/bus'
  import {required} from 'vuelidate/lib/validators'
  import helpers from '@mixins/helper'
  import {clone, cloneDeep, find} from 'lodash'

  const defaultPaperType = {
    id: '',
    submission_start_datetime: '',
    submission_end_datetime: '',
    knowledge_area: false,
    edit_limit_days: 0,
    author_limit: 0,
    max_submission_author: 0,
    keywords_limit: 0,
    screening: false,
    author_subscribed: false,
    advisor: false,
    max_limit_advisor: 0,
    co_advisor: false,
    max_limit_co_advisor: 0,
    order: 0,
    template: '',
    paper_type: {
      id: '',
      name: ''
    },
    fields: []
  }

  export default {
    name: 'event-paper-types',
    components: {ValidationMessage},
    mixins: [helpers],
    data () {
      return {
        isSubmitted: false,
        isLoadingData: true,
        modalPaperTypeVisible: false,
        paperTypeSelect: '',
        eventPaperTypes: [],
        dependencies: {
          paper_types: [],
          fields: []
        },
        event: {id: ''},
        paperType: clone(defaultPaperType)
      }
    },
    validations: {
      paperType: {
        submission_start_datetime: {required},
        submission_end_datetime: {required}
      }
    },
    mounted () {
      this.getDependencies().then(_ => {
        const id = this.$route.params.id || null
        this.loadData(id)
      })
    },
    methods: {
      getDependencies () {
        return new Promise((resolve) => {
          DataService.get([{domain: 'paper_type'}, {domain: 'field'}]).then((result) => {
            this.dependencies = result
            resolve()
          })
        })
      },
      loadData (id) {
        bus.$emit('show-loader')
        if (id) {
          this.isEdit = true
          restfulService.get('event', null, id, null, ['paper_types.paper_type', 'paper_types.fields.field'])
            .then(response => {
              this.event.id = response.id
              this.eventPaperTypes = response.paper_types
              this.isLoadingData = false
              bus.$emit('hide-loader')
            })
            .catch(e => {
              console.log(e)
              bus.$emit('hide-loader')
              this.isLoadingData = false
            })
        } else {
          bus.$emit('hide-loader')
          this.isLoadingData = false
        }
      },
      checkPaperTypeSelected (id) {
        return this.eventPaperTypes.some(item => item.paper_type_id === id)
      },
      selectPaperType () {
        if (this.paperTypeSelect && this.paperTypeSelect !== '') {
          const hasPaperType = this.eventPaperTypes.some(item => item.paper_type_id === this.paperTypeSelect)
          if (!hasPaperType) {
            const data = clone(defaultPaperType)
            data.paper_type = find(this.dependencies.paper_types, item => item.id === this.paperTypeSelect)
            data.paper_type_id = data.paper_type.id
            data.order = this.eventPaperTypes.length + 1
            this.savePaperType(data)
              .then(response => {
                data.id = response.id
                this.eventPaperTypes.push(data)
                this.paperTypeSelect = ''
                this.editPaperType(data)
                notifyService.success({hideLoader: true})
                bus.$emit('hide-loader')
                this.isSubmitted = false
              })
              .catch(e => {
                this.isSubmitted = false
                bus.$emit('hide-loader')
                console.log(e)
              })
          }
        }
      },
      onHandleModalPaperType () {
        this.modalPaperTypeVisible = !this.modalPaperTypeVisible
      },
      editPaperType (item) {
        const paperType = cloneDeep(item)
        const fields = cloneDeep(this.dependencies.fields)
        fields.forEach(item => {
          this.$set(item, 'checked', paperType.fields.some(field => field.field_id === item.id))
        })
        paperType.fields.splice(0)
        paperType.fields = fields
        this.paperType = paperType
        this.modalPaperTypeVisible = !this.modalPaperTypeVisible
      },
      savePaperType (paperType) {
        bus.$emit('show-loader')
        this.isSubmitted = true
        const data = cloneDeep(paperType)
        data.event_id = this.event.id
        data.submission_start_datetime = this.dateTimeFormat(data.submission_start_datetime, 'en')
        if (data.submission_start_datetime.length === 0) {
          delete data.submission_start_datetime
        }
        data.submission_end_datetime = this.dateTimeFormat(data.submission_end_datetime, 'en')
        if (data.submission_end_datetime.length === 0) {
          delete data.submission_end_datetime
        }
        return restfulService.save('event_paper_type', null, null, data)
      },
      onSavePaperType () {
        bus.$emit('show-loader')
        const data = cloneDeep(this.paperType)
        this.savePaperType(data)
          .then(response => {
            this.loadData(this.event.id)
            notifyService.success({hideLoader: true})
            this.isSubmitted = false
            this.onHandleModalPaperType()
            bus.$emit('hide-loader')
          })
          .catch(e => {
            this.isSubmitted = false
            bus.$emit('hide-loader')
            console.log(e)
          })
      },
      removePaperType (paperType) {
        restfulService.destroy('event_paper_type', null, paperType.id)
          .then(_ => {
            this.eventPaperTypes = this.eventPaperTypes.filter(item => item.paper_type_id !== paperType.paper_type_id)
            notifyService.success({hideLoader: true})
            this.isSubmitted = false
          })
          .catch(e => {
            this.isSubmitted = false
            console.log(e)
          })
      }
    }
  }
</script>

<template>
    <div v-if="!isLoadingData">
        <el-form ref="formSelectPaperType"
                 label-position="top">
            <el-form-item label="Adicionar Tipo de Trabalho">
                <el-select v-model="paperTypeSelect"
                           filterable
                           clearable
                           @change="selectPaperType"
                           placeholder="Selecione um tipo de trabalho"
                           empty-text="Nenhum registro encontrado"
                           class="el-select-full">
                    <el-option
                            v-for="item in dependencies.paper_types"
                            :key="item.id"
                            :disabled="checkPaperTypeSelected(item.id)"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div class="header-flex">
            <h2>Tipos de Trabalhos</h2>
        </div>
        <table class="custom-table-list paper-types-table">
            <thead>
            <tr>
                <th>Tipo</th>
                <th>Submissões</th>
                <th>Configurações</th>
                <th width="60">Ações</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in eventPaperTypes">
                <td>{{item.paper_type.name}}</td>
                <td>
                    <div><strong>Início:</strong> {{item.submission_start_datetime | dateTimeEnToBr}}</div>
                    <div><strong>Término:</strong> {{item.submission_end_datetime | dateTimeEnToBr}}</div>
                </td>
                <td>
                    <div><strong>Informar área do CNPq:</strong> {{item.knowledge_area ? 'Sim' : 'Não'}}</div>
                    <div><strong>Dias para edição:</strong> {{item.edit_limit_days}}</div>
                    <div><strong>Limite de autores:</strong> {{item.author_limit}}</div>
                    <div><strong>Limite de palavras-chave:</strong> {{item.keywords_limit}}</div>
                    <div><strong>Possui triagem:</strong> {{item.screening ? 'Sim' : 'Não'}}</div>
                    <div>
                        <strong>Co-autores precisam estar inscritos:</strong> {{item.author_subscribed ? 'Sim' : 'Não'}}
                    </div>
                    <div><strong>Precisa orientador:</strong> {{item.advisor ? 'Sim' : 'Não'}}</div>
                    <div><strong>Nº máximo de orientador(es):</strong> {{item.max_limit_advisor}}</div>
                    <div><strong>Precisa co-orientador:</strong> {{item.co_advisor ? 'Sim' : 'Não'}}</div>
                    <div><strong>Nº máximo de co-orientador(es):</strong> {{item.max_limit_co_advisor}}</div>
                </td>
                <td class="buttons">
                    <el-button type="info"
                               class="edit-paper-type"
                               @click="editPaperType(item)"
                               title="Editar Tipo de Trabalho">
                        <i class="fa fa-edit"></i>
                    </el-button>
                    <el-button type="danger"
                               @click="removePaperType(item)"
                               title="Remover Tipo de Trabalho">
                        <i class="fa fa-times"></i>
                    </el-button>
                </td>
            </tr>
            </tbody>
        </table>
        <el-dialog :title="'Dados do tipo de trabalho: ' + paperType.paper_type.name"
                   top="5vh"
                   v-if="modalPaperTypeVisible"
                   :visible.sync="modalPaperTypeVisible">
            <el-form ref="formPaperType"
                     class="form-paper-type"
                     label-position="top">
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="Data/Hora Início Submissões"
                                      class="is-required"
                                      v-bind:class="{ 'el-form-item--error': $v.paperType.submission_start_datetime.$error }">
                            <el-date-picker
                                    v-model="paperType.submission_start_datetime"
                                    type="datetime"
                                    format="dd/MM/yyyy HH:mm"
                                    placeholder="Data/Hora Início Submissões"
                                    @input="$v.paperType.submission_start_datetime.$touch()"/>
                            <validation-message
                                    v-if="!$v.paperType.submission_start_datetime.required && $v.paperType.submission_start_datetime.$dirty"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="Data/Hora Término Submissões"
                                      class="is-required"
                                      v-bind:class="{ 'el-form-item--error': $v.paperType.submission_end_datetime.$error }">
                            <el-date-picker
                                    v-model="paperType.submission_end_datetime"
                                    type="datetime"
                                    format="dd/MM/yyyy HH:mm"
                                    placeholder="Data/Hora Término Submissões"
                                    @input="$v.paperType.submission_end_datetime.$touch()"/>
                            <validation-message
                                    v-if="!$v.paperType.submission_end_datetime.required && $v.paperType.submission_end_datetime.$dirty"/>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="Informar área do CNPq?">
                            <el-switch v-model="paperType.knowledge_area"
                                       active-text="SIM"
                                       inactive-text="NÃO">
                            </el-switch>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="Possui triagem">
                            <el-switch v-model="paperType.screening"
                                       active-text="SIM"
                                       inactive-text="NÃO">
                            </el-switch>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="Co-author precisa estar inscrito">
                            <el-switch v-model="paperType.author_subscribed"
                                       active-text="SIM"
                                       inactive-text="NÃO">
                            </el-switch>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="Precisa orientador">
                            <el-switch v-model="paperType.advisor"
                                       active-text="SIM"
                                       inactive-text="NÃO">
                            </el-switch>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="Nº máximo de orientador(es)">
                            <el-input-number v-model="paperType.max_limit_advisor"
                                             :disabled="!paperType.advisor"
                                             :min="0"
                                             :step="1"
                                             :max="100"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="Limite de autores">
                            <el-input-number v-model="paperType.author_limit"
                                             :min="0"
                                             :step="1"
                                             :max="100"/>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="Precisa co-orientador">
                            <el-switch v-model="paperType.co_advisor"
                                       active-text="SIM"
                                       inactive-text="NÃO">
                            </el-switch>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="Nº máximo de co-orientador(es)">
                            <el-input-number v-model="paperType.max_limit_co_advisor"
                                             :disabled="!paperType.co_advisor"
                                             :min="0"
                                             :step="1"
                                             :max="100"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="Dias para edição">
                            <el-input-number v-model="paperType.edit_limit_days"
                                             :min="0"
                                             :step="1"
                                             :max="100"/>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="Limite de palavras-chave">
                            <el-input-number v-model="paperType.keywords_limit"
                                             :min="0"
                                             :step="1"
                                             :max="100"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="Limite de submissões por autor"
                                      v-if="false">
                            <el-input-number v-model="paperType.max_submission_author"
                                             :min="0"
                                             :step="1"
                                             :max="100"/>
                        </el-form-item>
                    </el-col>
                </el-row>
                <h3>Campos Obrigatórios da Submissão</h3>
                <div class="fields-check">
                    <div class="item"
                         v-for="field in paperType.fields"
                         @click="field.checked = !field.checked"
                         v-bind:class="{'-checked' : field.checked}">
                        <div class="name">{{field.name}}</div>
                        <div class="description">{{field.description}}</div>
                        <div class="size" v-if="field.type === 'text' || field.type === 'textarea'">
                            Min: {{field.min_size}} / Max: {{field.max_size}} (caracteres)
                        </div>
                        <div class="size" v-if="field.type === 'file'">
                            Min: {{bytesToSize(field.min_size)}} / Max: {{bytesToSize(field.max_size * 1024)}}
                        </div>
                    </div>
                </div>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button class="submit"
                           type="primary"
                           :disabled="$v.paperType.$invalid"
                           @click="onSavePaperType">
                    Salvar Alterações
                </el-button>
                <el-button @click="onHandleModalPaperType">Fechar</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<style lang="scss">
    .edit-paper-type {
        margin-bottom: 8px;
    }

    .paper-types-table {
        .buttons {
            text-align: center;
            .el-button {
                display: inline-block;
                margin: 5px 0;
            }
        }
    }

    .fields-check {
        display: flex;
        flex-wrap: wrap;
        > .item {
            margin: 0 6px 10px;
            border: 3px solid #e2e2e2;
            border-radius: 6px;
            padding: 6px 14px;
            max-width: 33%;
            &.-checked {
                border-color: #00a65a;
            }
            .name {
                color: #333;
                font-size: 16px;
            }
            .description {
                line-height: 16px;
            }
            .description,
            .size {
                color: #898989;
                font-size: 12px;
            }
            .size {
                font-weight: bold;
            }
        }
    }

    .form-paper-type {
        .el-form-item {
            border: 1px solid #e1e1e1;
            padding: 10px;
            border-radius: 4px;

            &.el-form-item--error {
                padding-bottom: 28px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// PaperTypes.vue?2e64afb3